import React from 'react'
import quality_1 from '../../assets/images/homePage/quality_1.svg'
import quality_2 from '../../assets/images/homePage/quality_2.svg'
import quality_3 from '../../assets/images/homePage/quality_3.svg'

const Qualities = () => {
  const quality = [
    {
      image: quality_1,
      title: 'Maximum Transparency',
      desc: 'Nulla consectetur libero nec consectetur sagittis.'
    },
    {
      image: quality_2,
      title: 'Diverse Opportunities',
      desc: 'Donec aliquet, quam bibendum mattis aliquet, libero libero consequat.'
    },
    {
      image: quality_3,
      title: 'By & For Our Users',
      desc: 'Curabitur sed laoreet nisl. Nullam tincidunt ut mi eu suscipit.'
    },
  ]

  return (
    <div className='border-t-[#22262B] border-t-[1px] border-b-[#22262B] border-b-[1px]'>
      <div className='main_container py-[30px] md:py-[80px]'>
        <div className='grid grid-cols-12 gap-x-[20px] lg:gap-x-[48px]'>
          {quality?.map((m, i) => <div className='col-span-12 md:col-span-4 mb-[30px] md:mb-0' key={i}>
            <img src={m.image} alt='name' className='h-[64px] w-auto object-contain' />
            <p className='text-[24px] text-white aeonik_medium leading-[30px] mt-[22px]'>{m.title}</p>
            <p className='text-[18px] text-[#808080] leading-[23px] aeonik_normal mt-[12px]'>{m.desc}</p>
          </div>)}
        </div>
      </div>

    </div>
  )
}

export default Qualities
